
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateDocumentTemplateDtoFormGroup() {
return new FormGroup({
    fileName: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    folder: new FormControl<string | undefined>('docx', [Validators.required, Validators.maxLength(200)]),
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(200)]),
    prettyName: new FormControl<string | undefined>(undefined, [Validators.maxLength(200)]),
    containertypeId: new FormControl<number | undefined>(undefined),
    statusId: new FormControl<number | undefined>(undefined),
    requiresProject: new FormControl<boolean | undefined>(false),
    requiresContact: new FormControl<boolean | undefined>(false),
    requiresDebtor: new FormControl<boolean | undefined>(false),
    requiresCreditor: new FormControl<boolean | undefined>(false),
    requiresReferral: new FormControl<boolean | undefined>(false),
    dataProvider: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    configJson: new FormControl<string | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
    selector: new FormControl<string | undefined>(undefined),
    fixedSenderId: new FormControl<number | undefined>(undefined),
})
;
}
      